module.exports = __webpack_public_path__ + "static/media/Icono informes.1e2a8e26.svg";